import React from 'react';
import {useDispatch} from 'react-redux';
import ActionBarButtons from '../scanpack/actionBarButtons';
import scanpackStyles from '../../style/scanpack';
import useWidth from '../scanToCartScanning/useWidth';
import {openAction} from '../../actions/productFirstActions';

const ActionRow = () => {
  const dispatch = useDispatch();
  const width = useWidth();

  return (
    <ActionBarButtons
      width={width}
      onPressRestartOrder={() => dispatch(openAction('RestartOrder'))}
      restartButtonDesign={scanpackStyles.restartButtonDesign}
      onPressAddNote={() => dispatch(openAction('AddNote'))}
      hideMiddleButton
    />
  );
};

export default ActionRow;
